import _toConsumableArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { SandpackClient, extractErrorDetails } from "@codesandbox/sandpack-client";
import * as React from "react";
import { getSandpackStateFromProps } from "../utils/sandpackUtils";
import { generateRandomId } from "../utils/stringUtils";
var Sandpack = React.createContext(null);
var BUNDLER_TIMEOUT = 30000; // 30 seconds timeout for the bundler to respond.

var SandpackProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SandpackProvider, _React$PureComponent);

  var _super = _createSuper(SandpackProvider);

  function SandpackProvider(props) {
    var _this;

    _classCallCheck(this, SandpackProvider);

    _this = _super.call(this, props);
    _this.timeoutHook = null;

    _this.handleMessage = function (msg) {
      if (_this.timeoutHook) {
        clearTimeout(_this.timeoutHook);
      }

      if (msg.type === "state") {
        _this.setState({
          bundlerState: msg.state
        });
      } else if (msg.type === "done" && !msg.compilatonError) {
        _this.setState({
          error: null
        });
      } else if (msg.type === "action" && msg.action === "show-error") {
        _this.setState({
          error: extractErrorDetails(msg)
        });
      } else if (msg.type === "action" && msg.action === "notification" && msg.notificationType === "error") {
        _this.setState({
          error: {
            message: msg.title
          }
        });
      }
    };

    _this.updateCurrentFile = function (newCode) {
      _this.updateFile(_this.state.activePath, newCode);
    };

    _this.updateFile = function (path, newCode) {
      var _a;

      if (newCode === ((_a = _this.state.files[_this.state.activePath]) === null || _a === void 0 ? void 0 : _a.code)) {
        return;
      }

      var _this$state = _this.state,
          files = _this$state.files,
          sandpackStatus = _this$state.sandpackStatus;
      var _this$props = _this.props,
          recompileMode = _this$props.recompileMode,
          recompileDelay = _this$props.recompileDelay;

      var newFiles = _objectSpread(_objectSpread({}, files), {}, _defineProperty({}, path, {
        code: newCode
      }));

      _this.setState({
        files: newFiles
      });

      if (sandpackStatus !== "running") {
        return;
      }

      if (recompileMode === "immediate") {
        Object.values(_this.clients).forEach(function (client) {
          client.updatePreview({
            files: newFiles
          });
        });
      }

      if (recompileMode === "delayed") {
        window.clearTimeout(_this.debounceHook);
        _this.debounceHook = window.setTimeout(function () {
          Object.values(_this.clients).forEach(function (client) {
            client.updatePreview({
              files: _this.state.files
            });
          });
        }, recompileDelay);
      }
    };

    _this.createClient = function (iframe, clientId) {
      var client = new SandpackClient(iframe, {
        files: _this.state.files,
        template: _this.state.environment
      }, {
        bundlerURL: _this.props.bundlerURL,
        startRoute: _this.props.startRoute,
        fileResolver: _this.props.fileResolver,
        skipEval: _this.props.skipEval,
        showOpenInCodeSandbox: !_this.openInCSBRegistered.current,
        showErrorScreen: !_this.errorScreenRegistered.current,
        showLoadingScreen: !_this.loadingScreenRegistered.current
      }); // Subscribe inside the context with the first client that gets instantiated.
      // This subscription is for global states like error and timeout, so no need for a per client listen
      // Also, set the timeout timer only when the first client is instantiated

      if (typeof _this.unsubscribe !== "function") {
        _this.unsubscribe = client.listen(_this.handleMessage);
        _this.timeoutHook = setTimeout(function () {
          _this.setState({
            sandpackStatus: "timeout"
          });
        }, BUNDLER_TIMEOUT);
      }
      /**
       * Register any potential listeners that subscribed before sandpack ran
       */


      if (_this.queuedListeners[clientId]) {
        Object.keys(_this.queuedListeners[clientId]).forEach(function (listenerId) {
          var listener = _this.queuedListeners[clientId][listenerId];
          var unsubscribe = client.listen(listener);
          _this.unsubscribeQueuedListeners[clientId][listenerId] = unsubscribe;
        }); // Clear the queued listeners after they were registered

        _this.queuedListeners[clientId] = {};
      }
      /**
       * Register global listeners
       */


      var globalListeners = Object.entries(_this.queuedListeners.global);
      globalListeners.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            listenerId = _ref2[0],
            listener = _ref2[1];

        var unsubscribe = client.listen(listener);
        _this.unsubscribeQueuedListeners[clientId][listenerId] = unsubscribe;
        /**
         * Important: Do not clean the global queue
         * Instead of cleaning the queue, keep it there for the
         * following clients that might be created
         */
      });
      return client;
    };

    _this.runSandpack = function () {
      Object.keys(_this.preregisteredIframes).forEach(function (clientId) {
        var iframe = _this.preregisteredIframes[clientId];
        _this.clients[clientId] = _this.createClient(iframe, clientId);
      });

      _this.setState({
        sandpackStatus: "running"
      });
    };

    _this.registerBundler = function (iframe, clientId) {
      if (_this.state.sandpackStatus === "running") {
        _this.clients[clientId] = _this.createClient(iframe, clientId);
      } else {
        _this.preregisteredIframes[clientId] = iframe;
      }
    };

    _this.unregisterBundler = function (clientId) {
      var client = _this.clients[clientId];

      if (client) {
        client.cleanup();
        delete _this.clients[clientId];
      } else {
        delete _this.preregisteredIframes[clientId];
      }
    };

    _this.setActiveFile = function (path) {
      _this.setState({
        activePath: path,
        editorState: "dirty"
      });
    };

    _this.openFile = function (path) {
      _this.setState(function (_ref3) {
        var openPaths = _ref3.openPaths;
        var newPaths = openPaths.includes(path) ? openPaths : [].concat(_toConsumableArray(openPaths), [path]);
        return {
          activePath: path,
          openPaths: newPaths,
          editorState: "dirty"
        };
      });
    };

    _this.dispatchMessage = function (message, clientId) {
      if (_this.state.sandpackStatus !== "running") {
        console.warn("dispatch cannot be called while in idle mode");
        return;
      }

      if (clientId) {
        _this.clients[clientId].dispatch(message);
      } else {
        Object.values(_this.clients).forEach(function (client) {
          client.dispatch(message);
        });
      }
    };

    _this.addListener = function (listener, clientId) {
      if (clientId) {
        if (_this.clients[clientId]) {
          var unsubscribeListener = _this.clients[clientId].listen(listener);

          return unsubscribeListener;
        } else {
          // When listeners are added before the client is instantiated, they are stored with an unique id
          // When the client is eventually instantiated, the listeners are registered on the spot
          // Their unsubscribe functions are stored in unsubscribeQueuedListeners for future cleanup
          var listenerId = generateRandomId();
          _this.queuedListeners[clientId] = _this.queuedListeners[clientId] || {};
          _this.unsubscribeQueuedListeners[clientId] = _this.unsubscribeQueuedListeners[clientId] || {};
          _this.queuedListeners[clientId][listenerId] = listener;

          var _unsubscribeListener = function _unsubscribeListener() {
            if (_this.queuedListeners[clientId][listenerId]) {
              // unsubscribe was called before the client was instantiated
              // common example - a component with autorun=false that unmounted
              delete _this.queuedListeners[clientId][listenerId];
            } else if (_this.unsubscribeQueuedListeners[clientId][listenerId]) {
              // unsubscribe was called for a listener that got added before the client was instantiated
              // call the unsubscribe function and remove it from memory
              _this.unsubscribeQueuedListeners[clientId][listenerId]();

              delete _this.unsubscribeQueuedListeners[clientId][listenerId];
            }
          };

          return _unsubscribeListener;
        }
      } else {
        // Push to the **global** queue
        var _listenerId = generateRandomId();

        _this.queuedListeners.global[_listenerId] = listener; // Add to the current clients

        var clients = Object.values(_this.clients);
        var currentClientUnsubscribeListeners = clients.map(function (client) {
          return client.listen(listener);
        });

        var _unsubscribeListener2 = function _unsubscribeListener2() {
          var unsubscribeQueuedClients = Object.values(_this.unsubscribeQueuedListeners); // Unsubscribing all listener registered

          unsubscribeQueuedClients.forEach(function (listenerOfClient) {
            var listenerFunctions = Object.values(listenerOfClient);
            listenerFunctions.forEach(function (unsubscribe) {
              return unsubscribe();
            });
          }); // Unsubscribing from the clients already created

          currentClientUnsubscribeListeners.forEach(function (unsubscribe) {
            return unsubscribe();
          });
        };

        return _unsubscribeListener2;
      }
    };

    _this._getSandpackState = function () {
      var _this$state2 = _this.state,
          files = _this$state2.files,
          activePath = _this$state2.activePath,
          openPaths = _this$state2.openPaths,
          startRoute = _this$state2.startRoute,
          bundlerState = _this$state2.bundlerState,
          editorState = _this$state2.editorState,
          error = _this$state2.error,
          sandpackStatus = _this$state2.sandpackStatus,
          environment = _this$state2.environment;
      return {
        files: files,
        environment: environment,
        openPaths: openPaths,
        activePath: activePath,
        startRoute: startRoute,
        error: error,
        bundlerState: bundlerState,
        status: sandpackStatus,
        editorState: editorState,
        setActiveFile: _this.setActiveFile,
        openFile: _this.openFile,
        updateCurrentFile: _this.updateCurrentFile,
        updateFile: _this.updateFile,
        runSandpack: _this.runSandpack,
        registerBundler: _this.registerBundler,
        unregisterBundler: _this.unregisterBundler,
        dispatch: _this.dispatchMessage,
        listen: _this.addListener,
        lazyAnchorRef: _this.lazyAnchorRef,
        errorScreenRegisteredRef: _this.errorScreenRegistered,
        openInCSBRegisteredRef: _this.openInCSBRegistered,
        loadingScreenRegisteredRef: _this.loadingScreenRegistered
      };
    };

    var _getSandpackStateFrom = getSandpackStateFromProps(props),
        activePath = _getSandpackStateFrom.activePath,
        openPaths = _getSandpackStateFrom.openPaths,
        files = _getSandpackStateFrom.files,
        environment = _getSandpackStateFrom.environment;

    _this.state = {
      files: files,
      environment: environment,
      openPaths: openPaths,
      activePath: activePath,
      startRoute: _this.props.startRoute,
      bundlerState: undefined,
      error: null,
      sandpackStatus: _this.props.autorun ? "initial" : "idle",
      editorState: "pristine",
      renderHiddenIframe: false
    };
    /**
     * List of functions to be registered in the client, once it has been created
     *
     * Use cases:
     * - Set a listener, but the client hasn't been created yet;
     * - Set a listener, but the client has already been created;
     * - A client already exists, set a new listener and then one more client has been created;
     */

    _this.queuedListeners = {
      global: {}
    };
    /**
     * Global list of unsubscribe function for the listeners
     */

    _this.unsubscribeQueuedListeners = {};
    _this.preregisteredIframes = {};
    _this.clients = {};
    _this.lazyAnchorRef = React.createRef();
    _this.errorScreenRegistered = React.createRef();
    _this.openInCSBRegistered = React.createRef();
    _this.loadingScreenRegistered = React.createRef();
    return _this;
  }

  _createClass(SandpackProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.props.autorun) {
        return;
      }

      if (this.lazyAnchorRef.current) {
        // If any component registerd a lazy anchor ref component, use that for the intersection observer
        var options = {
          rootMargin: "600px 0px",
          threshold: 0.1
        };
        this.intersectionObserver = new IntersectionObserver(function (entries) {
          var _a, _b;

          if (((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.intersectionRatio) > 0) {
            // Delay a cycle so all hooks register the refs for the sub-components (open in csb, loading, error overlay)
            setTimeout(function () {
              _this2.runSandpack();
            }, 50);
            (_b = _this2.intersectionObserver) === null || _b === void 0 ? void 0 : _b.unobserve(_this2.lazyAnchorRef.current);
          }
        }, options);
        this.intersectionObserver.observe(this.lazyAnchorRef.current);
      } else {
        // else run the sandpack on mount, with a slight delay to allow all subcomponents to mount/register components
        setTimeout(function () {
          return _this2.runSandpack();
        }, 50);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.template !== this.props.template || prevProps.activePath !== this.props.activePath || JSON.stringify(prevProps.openPaths) !== JSON.stringify(this.props.openPaths) || JSON.stringify(prevProps.customSetup) !== JSON.stringify(this.props.customSetup)) {
        var _getSandpackStateFrom2 = getSandpackStateFromProps(this.props),
            activePath = _getSandpackStateFrom2.activePath,
            openPaths = _getSandpackStateFrom2.openPaths,
            files = _getSandpackStateFrom2.files,
            environment = _getSandpackStateFrom2.environment;
        /* eslint-disable react/no-did-update-set-state */


        this.setState({
          activePath: activePath,
          openPaths: openPaths,
          files: files,
          environment: environment
        });

        if (this.state.sandpackStatus !== "running") {
          return;
        }

        Object.values(this.clients).forEach(function (client) {
          return client.updatePreview({
            files: files,
            template: environment
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.unsubscribe === "function") {
        this.unsubscribe();
      }

      if (this.timeoutHook) {
        clearTimeout(this.timeoutHook);
      }

      if (this.debounceHook) {
        clearTimeout(this.debounceHook);
      }

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(Sandpack.Provider, {
        value: this._getSandpackState()
      }, children);
    }
  }]);

  return SandpackProvider;
}(React.PureComponent);

SandpackProvider.defaultProps = {
  skipEval: false,
  recompileMode: "delayed",
  recompileDelay: 500,
  autorun: true
};
var SandpackConsumer = Sandpack.Consumer;
export { SandpackProvider, SandpackConsumer, Sandpack as SandpackReactContext };